// Distance unit helpers. The DB stores meters (Leaflet expects meters),
// but the entire UX is shown in feet.
export const M_PER_FT = 0.3048;
export const ftToM = (ft) => Math.round(Number(ft || 0) * M_PER_FT);
export const mToFt = (m) => Math.round(Number(m || 0) / M_PER_FT);
